import React, { useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, Button, FormControl, Select, MenuItem, OutlinedInput } from '@mui/material';
import HelpIcon from './HelpIcon';
import PropTypes from 'prop-types';

const HLINE_COLORS = [
  'rgba(229, 57, 53, 0.85)', // Red
  'rgba(30, 136, 229, 0.85)', // Blue
  'rgba(67, 160, 71, 0.85)', // Green
  'rgba(251, 192, 45, 0.85)', // Yellow
  'rgba(142, 36, 170, 0.85)', // Purple
  'rgba(255, 87, 34, 0.85)', // Orange
  'rgba(205, 220, 57, 0.85)', // Lime
  'rgba(96, 125, 139, 0.85)', // Blue Gray
];

const HorizontalLineDialog = ({ open, onClose, onRun }) => {
  const [color, setColor] = useState(HLINE_COLORS[0]);
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');

  const handleRun = () => {
    const num = parseFloat(price);
    if (!isNaN(num)) {
      onRun({ color, price: num, description });
      setPrice('');
      setColor(HLINE_COLORS[0]);
      setDescription('');
      // Do NOT call onClose here
    }
  };

  return (
    <Dialog open={open} onClose={() => {}} disableEnforceFocus PaperProps={{ style: { minWidth: 390, borderRadius: 12, maxHeight: 320, padding: 0 } }}>


      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.15rem', pb: 1, pt: 2, textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{flexGrow: 1, textAlign: 'center', paddingLeft: '48px'}}>Draw SR Lines</span>
        <HelpIcon helpKey="horizontalLineDialog" />
      </DialogTitle>
      <div style={{ paddingLeft: 24, paddingTop: 4, fontWeight: 500, fontSize: 15 }}>Select Overlay Color:</div>
      <DialogContent sx={{ pt: 0, pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <Select
              value={color}
              onChange={e => setColor(e.target.value)}
              renderValue={selected => (
                <Box display="flex" alignItems="center">
                  <span style={{ display: 'inline-block', width: 24, height: 24, borderRadius: 4, backgroundColor: selected, marginRight: 10, border: '1px solid #bbb' }} />
                  <span style={{ fontFamily: 'monospace', fontSize: 15 }}>{selected}</span>
                </Box>
              )}
            >
              {HLINE_COLORS.map(opt => (
                <MenuItem key={opt} value={opt}>
                  <Box display="flex" alignItems="center">
                    <span style={{ display: 'inline-block', width: 24, height: 24, borderRadius: 4, backgroundColor: opt, marginRight: 10, border: '1px solid #bbb' }} />
                    <span style={{ fontFamily: 'monospace', fontSize: 15 }}>{opt}</span>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <OutlinedInput
            type="number"
            value={price}
            onChange={e => setPrice(e.target.value)}
            sx={{ width: 100, ml: 2, height: 40, fontSize: 16, '& input': { textAlign: 'center', padding: '10px 8px' } }}
            inputProps={{ min: 0, step: 0.01, inputMode: 'decimal', pattern: '[0-9]*' }}
            placeholder="Price"
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
          <OutlinedInput
            value={description}
            onChange={e => setDescription(e.target.value)}
            sx={{ width: 215, height: 40, fontSize: 16, '& input': { textAlign: 'left', padding: '10px 8px' } }}
            placeholder="Line Description (optional)"
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, gap: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            sx={{ fontWeight: 600, background: '#e3e6ee', color: '#333', borderRadius: 2, boxShadow: 'none', minWidth: 90 }}
            onClick={onClose}
          >
            CLOSE
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ px: 4, fontWeight: 'bold', fontSize: 15 }}
            onClick={handleRun}
            disabled={price === ''}
          >
            RUN
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

HorizontalLineDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRun: PropTypes.func.isRequired,
};

export default HorizontalLineDialog;
